import React, { FC, memo } from "react";
import { CustomsDeclarationV2Props } from "types/customDeclaration";
import CustomsDeclarationV2Form from "./components/CustomsDeclarationV2Form";

const CustomsDeclarationV2: FC<CustomsDeclarationV2Props> = ({
  itemId,
  create,
  declarations: declarationsProp,
  onSubmit,
  readOnly,
  onCustomsDataChange,
  noPadding,
  autoFocus,
  isWizardStep,
  isShipmentImportCustomsDeclaration,
  hideFileImport,
  isShowHSCodeColumn,
  isHSCodeValidationRequired,
  submitEmptyDeclarations,
  ...rest
}) => {
  const declarations = declarationsProp.toJS
    ? declarationsProp.toJS()
    : declarationsProp;

  return (
    //@ts-ignore FIXME: Delete after refactoring redux
    <CustomsDeclarationV2Form
      declarations={declarations}
      itemId={itemId}
      create={create}
      onSubmit={onSubmit}
      readOnly={readOnly}
      onCustomsDataChange={onCustomsDataChange}
      noPadding={noPadding}
      autoFocus={autoFocus}
      isWizardStep={isWizardStep}
      isShipmentImportCustomsDeclaration={isShipmentImportCustomsDeclaration}
      hideFileImport={hideFileImport}
      isShowHSCodeColumn={isShowHSCodeColumn}
      isHSCodeValidationRequired={isHSCodeValidationRequired}
      submitEmptyDeclarations={submitEmptyDeclarations}
      {...rest}
    />
  );
};

export default memo(CustomsDeclarationV2);
